import { Typography } from '@material-ui/core';
import { createElement, FC } from 'react';

import { DynamicSchemaDefinitionFixed } from '../../../../../generated/graphql';
import Base from './Base';

type Props = {
  field: DynamicSchemaDefinitionFixed;
  className?: string;
};

const FixedField: FC<Props> = ({ field, className }) => (
  <Base field={field} labelPaddingTop={0} className={className}>
    <Typography>{field.value}</Typography>
  </Base>
);

export default FixedField;
